import { api } from "@/lib/api";
import { LIMITS, ERROR_MESSAGES } from "@/lib/constants";

export interface UploadImageResponse {
  message: string;
  url: string;
}

export interface UploadAnexoResponse {
  message: string;
  url: string;
  nome: string;
}

export const uploadService = {
  
  async uploadProjetoImagemViaBackend(file: File): Promise<string> {
    const formData = new FormData();
    formData.append("imagem", file);

    const response = await api.post<UploadImageResponse>(
      "/upload/projeto-imagem",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data.url;
  },
  async deleteImagemViaBackend(url: string): Promise<void> {
    await api.delete("/upload/imagem", {
      data: { url },
    });
  },

  
  getTransformedUrl(
    url: string,
    options: {
      width?: number;
      height?: number;
      resize?: "cover" | "contain" | "fill";
      format?: "webp" | "jpeg" | "png";
      quality?: number;
    }
  ): string {
    const params = new URLSearchParams();
    if (options.width) params.append("width", options.width.toString());
    if (options.height) params.append("height", options.height.toString());
    if (options.resize) params.append("resize", options.resize);
    if (options.format) params.append("format", options.format);
    if (options.quality) params.append("quality", options.quality.toString());

    return params.toString() ? `${url}?${params.toString()}` : url;
  },

  
  validateImage(file: File): { valid: boolean; error?: string } {
    if (!LIMITS.ALLOWED_IMAGE_TYPES.some((allowedType) => allowedType === file.type)) {
      return {
        valid: false,
        error: ERROR_MESSAGES.UPLOAD_INVALID_TYPE,
      };
    }

    if (file.size > LIMITS.IMAGE_MAX_SIZE_BYTES) {
      const sizeMB = (file.size / (1024 * 1024)).toFixed(1);
      return {
        valid: false,
        error: `Arquivo de ${sizeMB}MB é muito grande. O tamanho máximo permitido é ${LIMITS.IMAGE_MAX_SIZE_MB}MB. Reduza o tamanho da imagem antes de enviar.`,
      };
    }

    return { valid: true };
  },

  async uploadAnexo(file: File): Promise<{ url: string; nome: string }> {
    const formData = new FormData();
    formData.append("arquivo", file);

    const response = await api.post<UploadAnexoResponse>(
      "/upload/anexo",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return { url: response.data.url, nome: response.data.nome };
  },

  async getAnexoSignedUrl(ataId: number | string, url: string): Promise<string> {
    const response = await api.post<{ signedUrl: string }>(
      "/upload/anexo/signed-url",
      { ataId, url }
    );
    return response.data.signedUrl;
  },

  async uploadAvatarViaBackend(file: File): Promise<string> {
    const formData = new FormData();
    formData.append("imagem", file);

    const response = await api.post<{ avatar_url: string }>(
      "/upload/avatar",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data.avatar_url;
  },

  async deleteAvatarViaBackend(): Promise<void> {
    await api.delete("/upload/avatar");
  },
};
